var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    data: function data() {
        return {
            selectedAmenities: [],
            removedAmenities: [],
            amenities: [],
            unitTypes: [],
            verified_by: '',
            unit: {},
            selectedStatus: '',
            move_in_date: '',
            move_out_date: '',
            available_date: '',
            vacate_date: '',
            verified_date: '',
            users: [],
            move_in_date_display: false,
            statuses: [],
            unitStatus: ['Rented', 'Model', 'Down', 'Vacant - Not Leased', 'Vacant - Leased', 'NTV - Available', 'NTV - Leased', 'Shop', 'Rehab', 'Pending Approval'],
            unitMeasurements: [{
                bedroom_id: 0,
                name: 'Studio'
            }, {
                bedroom_id: 1,
                name: '1'
            }, {
                bedroom_id: 2,
                name: '2'
            }, {
                bedroom_id: 3,
                name: '3'
            }, {
                bedroom_id: 4,
                name: '4'
            }],
            loading: false,
            optionsLoading: false,
            unitType: '',
            unitID: '',
            isChanged: false
        };
    },
    mounted: function mounted() {
        var _this = this;

        var $el = this;

        Event.$on('edit-unit', function (unit) {
            $el.selectedStatus = unit.status;
            $el.move_in_date_display = unit.status == 'Vacant - Leased' ? true : false;
            $el.move_in_date = _this.dateFilter(unit.move_in_date);
            $el.move_out_date = _this.dateFilter(unit.move_out_date);
            $el.available_date = _this.dateFilter(unit.available_date);
            $el.vacate_date = _this.dateFilter(unit.vacate_date);
            $el.verified_date = _this.dateFilter(unit.verified_date);
            $el.verified_by = unit.verified_by ? { id: unit.verified_by.id, name: unit.verified_by.first_name + ' ' + unit.verified_by.last_name } : '';
            $el.unitID = unit.id;
            $el.isChanged = false;
            $el.$children[0].$data.showModal = true;
            $el.refreshData();
        });

        axios.get("/prototype/units/get-verified-list").then(function (response) {
            $el.usersRaw = response.data;
            var payLoadUser = [];
            $el.usersRaw.map(function (usersR) {
                payLoadUser.push({ "id": usersR.id, "name": usersR.first_name + ' ' + usersR.last_name });
            });
            $el.users = payLoadUser;
        });
    },


    computed: {
        filteredAmenities: function filteredAmenities() {
            var _this2 = this;

            return this.amenities.filter(function (propAmen) {
                return !_this2.selectedAmenities.find(function (unitAmen) {
                    return unitAmen.amenities_id === propAmen.amenities_id;
                });
            });
        },
        doneLoading: function doneLoading() {
            return !this.optionsLoading && !this.loading;
        }
    },

    methods: {
        marketRentAmount: function marketRentAmount() {
            if (this.unit.unit_type_id !== this.unitType.id || this.isChanged) {
                this.unit.market_rent_amount = this.unitType.market_rent_unit_type;
                this.isChanged = true;
            }
        },
        dateFilter: function dateFilter(value) {
            if (moment(value).isValid()) return moment(value).format('MM/DD/YYYY');
        },
        removeAmenity: function removeAmenity(unitAmenity) {
            var index = this.selectedAmenities.indexOf(unitAmenity);
            var amenityToRemove = this.selectedAmenities[index];
            //Track live record removals
            if (amenityToRemove.id !== null) {
                this.removedAmenities.push(amenityToRemove);
            }
            this.selectedAmenities.splice(index, 1);
        },
        addAmenity: function addAmenity(propAmenity) {
            var removedIndex = this.removedAmenities.findIndex(function (removedAmen) {
                return removedAmen.amenity_name === propAmenity.amenity_name;
            });
            //Restore a removed live record if able
            if (removedIndex > -1) {
                this.selectedAmenities.push(this.removedAmenities[removedIndex]);
                this.removedAmenities.splice(removedIndex, 1);
            } else {
                //Merge the propertyAmenity record into the unitAmenties list
                this.selectedAmenities.push(_extends({}, propAmenity, {
                    id: null,
                    amenities_property_id: propAmenity.id
                }));
            }
        },
        refreshData: function refreshData() {
            var _this3 = this;

            this.loading = true;
            this.optionsLoading = true;
            this.amenities = [];
            this.selectedAmenities = [];
            this.removedAmenities = [];
            if (this.unitID) {
                axios.get('/prototype/units/' + this.unitID).then(function (response) {
                    if (response.data) {
                        _this3.unit = response.data;
                        _this3.unitType = _this3.unit.unit_type;
                        _this3.selectedAmenities = _this3.unit.amenities;

                        _this3.loading = false;
                    }
                });

                axios.post('/prototype/units/options').then(function (response) {
                    if (response.data) {
                        _this3.amenities = response.data.amenities;
                        _this3.unitTypesRaw = response.data.unitTypes;
                        _this3.buildings = response.data.buildings;
                        _this3.statuses = response.data.statuses;
                        var payLoad = [];
                        _this3.unitTypesRaw.map(function (unitTypesR) {
                            if (unitTypesR.name) {
                                payLoad.push({ "id": unitTypesR.id, "name": unitTypesR.name, "market_rent_unit_type": unitTypesR.market_rent_unit_type });
                            }
                        });
                        _this3.unitTypes = payLoad;
                        _this3.optionsLoading = false;
                    }
                });
            }
        },
        close: function close() {
            Event.$emit('close-full-modal');
        },
        save: function save() {
            var _this4 = this;

            this.loading = true;
            this.unit.unit_type_id = this.unitType.id;
            this.unit.status = this.selectedStatus;
            this.unit.move_in_date = this.move_in_date;
            this.unit.move_out_date = this.move_out_date;
            this.unit.available_date = this.available_date;
            this.unit.verified_date = this.verified_date;
            this.unit.vacate_date = this.vacate_date;
            this.unit.verified_by = this.verified_by.id;
            axios.post('/prototype/units/' + this.unit.id, {
                unit: this.unit,
                amenities: this.selectedAmenities,
                removedAmenities: this.removedAmenities
            }).then(function (response) {
                if (response.data) {
                    _this4.loading = false;
                    Event.$emit('unit-added');
                    _this4.$children[0].$data.showModal = false;
                }
            });
        }
    },
    watch: {
        selectedStatus: function selectedStatus() {
            if (this.selectedStatus == 'Vacant - Leased') {
                this.move_in_date_display = true;
            } else {
                this.move_in_date_display = false;
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/unit/EditUnit.vue
// module id = uzX0
// module chunks = 0 1